import { Periodo } from '../@types/periodo';
import aqilaApi from './aqila-api';

class Periodos {
  private readonly endpoint = 'v1/periodos';

  async list() {
    const { data } = await aqilaApi.get<Periodo[]>(this.endpoint);

    return data;
  }
}

export default new Periodos();
